import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';

import { submit, change, isSubmitting } from 'redux-form';

import Button from 'components/common/Button';
import NarrativeCreateEditForm from './NarrativeCreateEditForm';

const styles = theme => ({
  form: {
    overflow: 'hidden',
    padding: '55px 55px 50px',
    [theme.breakpoints.down('sm')]: {
      padding: '16px 8px 16px',
    },
  },
});

const NarrativeCreateEditDialog = ({
  form,
  open,
  initialValues,
  onClose,
  onSubmitSuccess,
  submitting,
  actions,
  classes,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
  >
    <DialogTitle onCloseClick={onClose}>
      <Typography
        variant="title"
        color="secondary"
        align="center"
      >
        Add Narrative
      </Typography>
    </DialogTitle>
    <DialogContent withScrollbars>
      <NarrativeCreateEditForm
        className={classes.form}
        form={form}
        {...initialValues ? { initialValues } : {}}
        onSubmit={(values) => values}
        onSubmitSuccess={(values) => {
          onClose();
          onSubmitSuccess(values);
        }}
      />
    </DialogContent>
    <DialogActions>
      <Button
        onClick={() => {
          actions.change(form, 'Narrative', '');
        }}
        variant="raised"
      >
        Clear
      </Button>
      <Button
        onClick={() => actions.submit(form)}
        variant="raised"
        color="primary"
        disabled={submitting}
      >
        Save
      </Button>
    </DialogActions>
  </Dialog>
);

NarrativeCreateEditDialog.propTypes = {
  open: PropTypes.bool,
  form: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  onSubmitSuccess: PropTypes.func,
  submitting: PropTypes.bool.isRequired,
  initialValues: PropTypes.shape({
    Narrative: PropTypes.string,
  }),
  actions: PropTypes.shape({
    submit: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    form: PropTypes.string.isRequired,
  }).isRequired,
};

NarrativeCreateEditDialog.defaultProps = {
  open: false,
  initialValues: null,
  onClose: () => {},
  onSubmitSuccess: () => {},
};

const mapStateToProps = (store, ownProps) => ({
  submitting: isSubmitting(ownProps.form)(store),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ submit, change }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(NarrativeCreateEditDialog),
);



// WEBPACK FOOTER //
// ./src/components/workflow/NarrativeCreateEditDialog/NarrativeCreateEditDialog.js